import { Paso } from './Paso';

export class PasoMother extends Paso {
  constructor() {
    super(
      true,
      'Mother',
      'Es donde se conectarán todos los componentes de tu PC. Según el modelo que elijas tendrás diferentes beneficios de conectividad y expansión',
      2,
      'mother.png',
      'mother.png',
      false,
      [],
      '',
    );
  }
}
